import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnDestroy,
} from "@angular/core";
import { SharedDataService } from "../../shared/sharedData.service";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";
import { TimesheetService } from "../../shared/services/timesheet.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ModalCreateTimesheetComponent } from "./modal-create/modal-create-timesheet.component";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { forkJoin, Observable } from "rxjs";
import { AuthorizationService } from "../../shared/services/authorization.service";
import * as _ from "lodash";

@Component({
    selector: "create-timesheet",
    templateUrl: "./create-ts.component.html",
    standalone: false
})
export class CreateTSComponent implements OnInit, OnDestroy {
    constructor(
        private _modalService: BsModalService,
        private _sharedDataService: SharedDataService,
        private authorizationService: AuthorizationService,
        private _eventBus: EventBusService,
        private timesheetService: TimesheetService,
        private router: Router,
        private log: NbcLoggerService
    ) {}

    private subs = new SubSink();
    @Input() selectedBusinessUnit: any;
    @Input() departments: any[] | undefined;
    departmentId: any;
    businessUnitId: any;
    selectedBuAccess: any;
    buAccess: any;
    operationTalentDept: any;
    departmentsWithTimesheets = ["SUBMITTER"];
    businessUnits: any;
    BuAccess: any;
    bsModalRef?: BsModalRef;
    queryContainer: any;

    //@Output() queryContainer = new EventEmitter<any>();

    searchButtonDisable = false;

    getQueryContainer() {
        const query = this.timesheetService.getTimesheetSummaryQuery();
        return {
            query: query,
        };
    }

    searchObj = {
        selectedBusinessUnitId: "",
        departmentId: "",
        description: "",
    };

    openCreateTimeSheetModal() {
        //let bsModalRef: BsModalRef;
        const initialState: any = {
            userBuAccess: this.selectedBuAccess,
            businessUnitId: this.businessUnitId,
            departmentId: this.departmentId,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        this.bsModalRef = this._modalService.show(
            ModalCreateTimesheetComponent,
            modalOptions
        );
        this.bsModalRef.content.onSync.subscribe((result) => {
            // this._eventBus.emit(new EmitEvent("CreateTimesheetModal", "searchTemplates", null));
            this.log.trace("Modal dismissed with: " + result);
            this.redirectSummary(result.timesheetBatch.id);
        });
    }

    redirectSummary(id) {
        this.router.navigate([
            "/bu/" + this.selectedBusinessUnit.id + "/batch/" + id,
        ]);
    }

    search() {
        this.log.trace("Get Searcg");
        this.queryContainer.query.businessUnitId = this.selectedBusinessUnit;
        this.queryContainer.query.currentPage = 1;
        this.searchObj.selectedBusinessUnitId = this.selectedBusinessUnit.id;
        this.searchObj.departmentId = this.departmentId;
        this.searchObj.description =
            this.queryContainer.query.searchTerm.description;
        this._eventBus.emit(
            new EmitEvent(
                "create-timesheet:onSearch",
                "contactSearch",
                this.searchObj
            )
        );
    }

    reset() {
        this.searchObj.description = "";
        this.searchObj.selectedBusinessUnitId = this.selectedBusinessUnit.id;
        this.searchObj.departmentId = this.departmentId;
        this.queryContainer.query.searchTerm.description = "";
        this.queryContainer.query.currentPage = 1;
        this._eventBus.emit(
            new EmitEvent(
                "create-timesheet:onSearch",
                "contactSearch",
                this.searchObj
            )
        );
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;
        this._eventBus.emit(
            new EmitEvent(
                "onBUClicked",
                "eventSearch",
                this.selectedBusinessUnit
            )
        );
    }

    getData = () => {
        const buAccess$ = this.authorizationService.getBUAccess(
            this.selectedBuAccess.businessUnitId
        );
        this.subs.sink = forkJoin(buAccess$).subscribe(([access]) => {
            this.configureBusinessUnitAccess(access.reference);
        });
    };

    configureBusinessUnitAccess(access: any) {
        this.buAccess = access;
        this.operationTalentDept = _.includes(
            this.departmentsWithTimesheets,
            this.buAccess.department
        );
    }

    buAccessSelected(data: any) {
        this.selectedBuAccess = data;
        this.departmentId = this.selectedBuAccess.departmentId;
        this.businessUnitId = this.selectedBuAccess.businessUnitId;
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe(
                (access) => (this.buAccess = this.buAccessSelected(access))
            );
    }

    ngOnInit() {
        this.subscribeEventHandlers();
        this.queryContainer = this.getQueryContainer();
        this.getData();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
